<template>
  <!-- <div> -->
  <ul class="l_tree">
    <li class="l_tree_branch" v-for="item in trees" :key="item.id">
      <div class="l_tree_click">
        <!-- <button type="button" class="l_tree_children_btn" v-if="item.children" @click="toggle(item)">{{ !item.show ? '-' : '+' }}</button> -->
        <span
          class="l_folder"
          :class="{
            treeTrue: item.type == 1 && item.show == true,
            treeOne: item.type == 1 && item.show == false,
            treeTwo: item.type == 2,
            'treeTwo:hover': item.type == 2
          }"
          @click="nodeClickFun(item)"
          >{{ item.name }}
        </span>
      </div>
      <ew-tree
        v-show="item.show"
        v-if="item.children"
        :model="item.children"
      ></ew-tree>
    </li>
  </ul>
  <!-- </div> -->
</template>

<script>
/**
 *
 * 定义一个字段，存右侧当前显示的Id
 */
export default {
  name: "ewTree",
  props: ["model"],
  data() {
    return {
      trees: this.model,
      divId: ""
    };
  },
  watch: {
    model(value) {
      this.trees = this.model;
    }
  },
  methods: {
    /**
     * 节点点击事件
     * @param {Object} item 节点对象
     */
    nodeClickFun(item) {
      ///判断是否为目录
      if (item.type == 1) {
        // 是目录，那么我们执行展开或闭合操作
        this.toggle(item);
      } else {
        // 不是目录，那么我们执行跳转页面操作
        this.toView(item);
      }
    },

    toggle(item) {
      let that = this;
      for (let i = 0; i < that.trees.length; i++) {
        if (that.trees[i].id == item.id) {
          that.trees[i].show = !that.trees[i].show;
        }
      }
    },

    toView(item) {
      // 当你点击的时候，更换一下你存储的Id
      this.divId = item.id;
      let path = item.path;
      let that = this;
      this.$router.push({
        path: "/simple",
        query: {
          catalogId: item.id,
          catalogName: item.name
        }
      });
      /* setTimeout(function(){
					location.reload()
				}, 10) */
      /* setTimeout(function() {
					that.$router.push({
						name: path,
						params: {
							catalogId: item.id,
							name: item.name
						}
					})
				}, 20);
				this.$router.back(-1); */
    }
  }
};
</script>

<style>
.treeTrue {
  font-size: 16px;
  font-weight: bold;
  color: #ccb356;
}

.treeOne {
  font-size: 16px;
  /* font-weight: bold; */
  color: #595757;
}

.treeTwo {
  font-size: 14px;
}

.treeTwo:hover {
  color: #ccb356;
}

* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

*:before,
*:after {
  box-sizing: border-box;
}

ul,
li {
  list-style: none;
}

.l_tree_container {
  height: 100%;
  /* margin: 13px; */
  margin: 0px 0 13px -32px;
  position: relative;
}

.l_tree {
  width: calc(100% - 36px);
  height: 100%;
  /* padding-left: 42px; */
  padding-left: 28px;
}

.l_tree_branch {
  width: 100%;
  height: 100%;
  display: block;
  /* padding: 13px; */
  padding: 4px;
  position: relative;
}

.l_tree_branch .l_tree_children_btn {
  width: 26px;
  height: 26px;
  border-radius: 50%;
  background-color: #2283c1;
  font-size: 23px;
  text-align: center;
  color: #ffffff;
  outline: none;
  border: 0;
  cursor: pointer;
  /* + */
  display: none;
}

ul.l_tree:before {
  content: "";
  border-left: 1px solid #c4c4c4;
  /* height: calc(100%); */
  height: calc(89%);
  position: absolute;
  left: 10px;
  top: 0px;
}

.l_tree .l_tree_branch:last-child::before {
  content: "";
  width: 3px;
  height: calc(100% - 24px);
  display: block;
  background-color: #ffffff;
  position: absolute;
  bottom: 0;
  left: -34px;
}

.l_tree,
.l_tree_branch {
  position: relative;
}

.l_tree_branch::after {
  /* content: '';
		width: 40px;
		height: 0;
		border-bottom: 1px solid #000;
		position: absolute;
		right: calc(100% - 9px);
		top: 22px; */
  content: "";
  width: 16px;
  height: 0;
  border-bottom: 1px solid #c4c4c4;
  position: absolute;
  right: calc(100% - -1px);
  top: 17px;
}

.l_tree_container > .l_tree::before,
.l_tree_container > .l_tree > .l_tree_branch::after {
  display: none;
}

.l_folder {
  border-radius: 5px;
  /* border: 3px #096eae solid; */
  /* padding: 2px 10px 2px 10px; */
  padding: 2px 10px 2px 2px;
  cursor: pointer;
}
</style>
